<template>
  <div class="fuel-consumption-vessel-list">
    <vx-card>
      <div
        v-if="vessels.length === 0"
        class="no-vessels-view flex items-center justify-center"
      >
        {{ msg }}
      </div>
      <div class="vessel-list">
        <vs-divider v-if="vessels.length > 0" class="m-0 p-0"></vs-divider>
        <div v-for="(item, index) in vesselList" :key="index" class="">
          <fuel-consumption-vessel-card
            :vessel="item"
            :clickVoyageFunc="moveVoyageListView"
            :clickPeriodFunc="showPeriodDialog"
            :clickExportFunc="exportCSV"
          ></fuel-consumption-vessel-card>
          <vs-divider class="m-0 p-0"></vs-divider>
        </div>
      </div>

      <!-- pagenation -->
      <div id="pagenation-area" class="flex items-center justify-end mt-4">
        <!-- 件数変更 -->
        <div class="w-full">
          <div class="flex items-center justify-end">
            <div
              class="px-6 py-2 border border-solid d-theme-border-grey-light rounded-full flex items-center justify-center"
            >
              <span class="aisea-text-14-400-black">
                {{ startVesselNum }}-{{ endVesselNum }} / {{ totalVesselCount }}
              </span>
            </div>
          </div>
        </div>
        <!-- ページ変更 -->
        <vs-pagination
          :total="totalPages"
          :color="AISEA_COLOR.BLUE"
          :max="maxPaginationCount"
          v-model="currentPage"
          class="pagination-view ml-4"
        ></vs-pagination>
      </div>
    </vx-card>

    <fuel-consumption-period-dialog ref="FuelConsumptionPeriodDialog" />
    <fuel-consumption-export-dialog ref="FuelConsumptionExportDialog" />
  </div>
</template>

<script>
import { VesselMixin, ColorMixin } from "@/mixins";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState, mapMutations } = createNamespacedHelpers(
  "fuelConsumption"
);
import FuelConsumptionVesselCard from "./components/FuelConsumptionVesselCard.vue";
import FuelConsumptionPeriodDialog from "./components/FuelConsumptionPeriodDialog.vue";
import FuelConsumptionExportDialog from "./components/FuelConsumptionExportDialog.vue";

export default {
  mixins: [VesselMixin, ColorMixin],
  components: {
    FuelConsumptionVesselCard,
    FuelConsumptionPeriodDialog,
    FuelConsumptionExportDialog,
  },
  data() {
    return {
      selectedVesselId: "",
      selectedVesselName: "",
      pageSize: 50,
      currentPage: 1,
      msg: "",
    };
  },
  computed: {
    ...mapState(["vessels", "vesselTotalPage", "vesselTotalElements"]),
    vesselList() {
      if (!this.vessels) return [];
      return this.vessels;
    },
    totalVesselCount() {
      if (!this.vesselTotalElements) return 0;
      return this.vesselTotalElements;
    },
    startVesselNum() {
      return (this.currentPage - 1) * this.pageSize + 1;
    },
    endVesselNum() {
      return Math.min(this.currentPage * this.pageSize, this.totalVesselCount);
    },
    maxPaginationCount() {
      return 7;
    },
    totalPages() {
      if (!this.vesselTotalPage) return 0;
      return this.vesselTotalPage;
    },
  },
  watch: {
    currentPage() {
      this.fetch();
    },
  },
  methods: {
    ...mapActions(["fetchVesselList"]),
    ...mapMutations(["SET_VESSELS"]),
    moveDetail(vessel) {
      this.$router.push({
        name: "fuel-consumption-voyage-list",
        params: { vesselId: vessel.id },
      });
    },
    moveVoyageListView(vessel) {
      this.moveDetail(vessel);
    },
    showPeriodDialog(vesselId) {
      this.selectedVesselId = vesselId;
      this.$refs.FuelConsumptionPeriodDialog.show(this.selectedVesselId);
    },
    exportCSV(vessel) {
      this.selectedVesselId = vessel.id;
      this.$refs.FuelConsumptionExportDialog.show(
        this.selectedVesselId,
        vessel.name
      );
    },
    async fetch() {
      try {
        this.$vs.loading();
        this.SET_VESSELS([]);
        const page = this.currentPage - 1;
        await this.fetchVesselList(page);
        this.$vs.loading.close();
      } catch (error) {
        console.error(error);
        let msg = error.msg;
        if (!msg) {
          msg = "予期せぬエラーが発生しました。";
        }
        this.msg = "船舶が見つかりませんでした。";
        this.$vs.notify({
          title: msg,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square",
        });
        this.$vs.loading.close();
      }
    },
    initLayout() {
      let routerViewElement = document.getElementsByClassName("router-view");
      routerViewElement[0].style.padding = "2.2rem";
    },
  },
  mounted() {
    this.initLayout();
    this.fetch();
  },
  beforeDestroy() {},
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/_typography.scss";

.fuel-consumption-vessel-list {
  font-family: $aisea-font-family;

  .vx-card {
    height: 88vh;
  }

  .no-vessels-view {
    height: 80vh;
  }

  .vessel-list {
    overflow-y: scroll;
    height: 78vh;
  }

  .pagination-view {
    width: auto !important;
    .vs-pagination--mb {
      margin: 0;
    }
  }
}
</style>
